<template>
  <div
    class="live-icon-parts"
    :class="{ 'live-icon-parts--live': isLiveEnabled }"
    @click="onLiveClicked"
  >
    LIVE
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'

/**
 * レース動画再生画面 動画プレーヤー LIVEアイコン コンポーネント
 */
export default defineComponent({
  name: 'LiveIconParts',
  props: {
    /**
     * LIVE表示有効化フラグ
     */
    isLive: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const isLiveEnabled = computed(() => props.isLive)
    return {
      isLiveEnabled,
    }
  },
  methods: {
    /**
     * LIVEボタンがクリックされた場合に呼び出される。
     */
    onLiveClicked() {
      this.$emit('onLiveClicked')
    },
  },
})
</script>

<style lang="scss" scoped>
.live-icon-parts {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 24px;
  border-radius: 2px;
  background: rgba(0, 0, 0, 70%);

  @include fontSetTextSmall(12);

  font-weight: 600;
  color: rgba(255, 255, 255, 70%);

  @media screen and (max-width: 374px) {
    width: 40px;
  }

  &--live {
    color: $black;
    background: $green-light;
  }
}
</style>
